// LINKS LIST OF PAGES

// General questions
export const generalQuestions = [
    {
        link: '#',
        qn: 'How do I set up Immerse?'
    },
    {
        link: '#',
        qn: 'What languages can I learn in Immerse?'
    },
    {
        link: '#',
        qn: 'What is Immerse?'
    },
    {
        link: '#',
        qn: 'Will I be talking to real people?'
    },
    {
        link: '#',
        qn: 'Do I need a VR headset to use Immerse?'
    },
    {
        link: '#',
        qn: 'What is an Immerse "className"?'
    },
    {
        link: '#',
        qn: 'Can I start learning with no experience in the language?'
    },
    {
        link: '#',
        qn: 'Where in real life do I set up for an Experience?'
    },
    {
        link: '#',
        qn: 'How do I start a Free Trial'
    },
    {
        link: '#',
        qn: 'Immerse Key Terms'
    },

];

// My membership
export const myMembership = [
    {
        link: '#',
        qn: 'How do I cancel my membership?'
    },
    {
        link: '#',
        qn: 'How do I sign up for classes?'
    },
    {
        link: '#',
        qn: 'What payment methods are accepted?'
    },
    {
        link: '#',
        qn: 'Where do I find info on my classes?'
    },
    {
        link: '#',
        qn: 'How do I access my dashboard?'
    },
    {
        link: '#',
        qn: 'How do I join a Class?'
    },
    {
        link: '#',
        qn: 'How do I change my appearance in Immerse?'
    },
    {
        link: '#',
        qn: 'I had a problem with my purchase'
    },
    {
        link: '#',
        qn: 'I am not able to press "confirm" when paying for the application'
    },
    {
        link: '#',
        qn: 'How do I track my progress?'
    },

];

// Troubleshooting and feedback
export const feedback = [
    {
        link: '#',
        qn: 'App Update: October 31st, 2022'
    },
    {
        link: '#',
        qn: 'I am unable to connect to Immerse'
    },
    {
        link: '#',
        qn: 'I need to report a bug'
    },
    {
        link: '#',
        qn: 'How do I recommend a new class or scene?'
    },
    {
        link: '#',
        qn: 'How do I get a refund?'
    },
    {
        link: '#',
        qn: "Why can't other people hear me?"
    },
    {
        link: '#',
        qn: 'How do I give feedback on a teacher?'
    },
    {
        link: '#',
        qn: 'Where do I go with questions about my headset?'
    },
    {
        link: '#',
        qn: 'App Update: September 2nd, 2022'
    },
    {
        link: '#',
        qn: 'How do I fix an echo in my mic?'
    },

];